import schedule from './schedule.vue' //进度
import task from './task.vue' //任务
import supplier from './supplier.vue' //供应商 
import contract from './contract.vue' //合同
import invoice from './invoice.vue' //发票列表
import contractInvoicelist from './contractInvoicelist.vue' //总发票列表
import addtask from './addtask.vue'//新增任务
import addproject from './addproject.vue'//新增项目
import addContract from "./addContract.vue" //新增合同
import supplierInfo from "./supplierInfo.vue" //供应商详情
import addInvoice from "./addInvoice.vue" //新增发票
import addcontractInvoice from "./addcontractInvoice.vue" //新增合同发票
import addProcess from "./addProcess.vue" //新增项目流程
import panorama from "./panorama.vue" //全景
let a = Object.assign({ schedule, task, supplier, addtask, contract, addproject, addContract, supplierInfo, invoice, addInvoice, addcontractInvoice, addProcess, panorama, contractInvoicelist })
export default a
